import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'

const ChatRisks = () => {
  return (
    <Screen
      title={<span><StyledScreen.GreenText>Риски</StyledScreen.GreenText> бесконтрольной переписки с клиентом</span>}
      bottomLine
      className='chat-risks'
    >
      <div className='chat-risks__container'>
        <ul className='chat-risks__text-list'>
          <li className='chat-risks__text-list-item'><strong>1. Потеря клиента.</strong> Если менеджер уволится из компании, он может забрать клиента с собой или просто не передать контакт.</li>
          <li className='chat-risks__text-list-item'><strong>2. Потеря истории общения с клиентом.</strong> Это может привести к негативу со стороны клиента — менеджеру придется уточнять одну и ту же информацию, а клиенту отвечать на одни и те же вопросы.</li>
          <li className='chat-risks__text-list-item'><strong>3. Сложность передачи клиента.</strong> Отсутствие полной истории общения затруднит передачу клиента другому менеджеру.</li>
          <li className='chat-risks__text-list-item'><strong>4. Отсутствие контроля.</strong> Вы не сможете осуществлять контроль и оценку качества работы менеджеров в переписке, в то время как этот канал коммуникации влияет на продажи.</li>
        </ul>
      </div>
    </Screen>
  )
}

export default ChatRisks;